/*
 * @Author: 刘小博
 * @Date: 2023-02-17 14:17:32
 * @LastEditTime: 2023-04-13 11:31:07
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\abutment-module\abutment-manage\modules\logRouter.js
 * 日志
 */
const logRouter = [
  // 对接模块 对接日志
  {
    path: '/s2pDataApi/log',
    name: 's2pDataApiLogPage',
    component: () =>
      import(
        /*webpackChunkName:"s2pDataApi" */
        '@/views/s2pDataApi/LogPage.vue'
      ),
    meta: {
      SecondaryMenu: '日志', //二级菜单
      title: '对接日志',
    },
  },
  // 对接模块 拉取日志
  {
    path: '/s2pDataApi/pulllog',
    name: 's2pDataApiPullLog',
    component: () =>
      import(
        /*webpackChunkName:"s2pDataApi" */
        '@/views/s2pDataApi/PullLog.vue'
      ),
    meta: {
      SecondaryMenu: '日志', //二级菜单
      title: '拉取日志',
    },
  },
]

export default logRouter
